import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact";
import { productImagePlaceholder } from "../helpers";
import { StarRating, CornerTreatment, VariantsRelated } from "./elements";
import { useState, useEffect } from "preact/hooks";


export default function Product({ product, lid }) {
    const { format } = useCurrencyFormatting();
    const [isInWishlist, setIsInWishlist] = useState(false);
    const [loadingWishlist, setLoadingWishlist] = useState(true);

    const [primaryImage, setPrimaryImage] = useState(product.imageUrl || productImagePlaceholder);
    const [secondaryImage, setSecondaryImage] = useState(product.alternateImageUrls?.[0] || null);
    const [price, setPrice] = useState(format(product.price));
    const [comparePrice, setComparePrice] = useState(format(product.listPrice));

    function handleVariantClick(primary, secondary, price, comparePrice) {
        setPrimaryImage(primary);
        setSecondaryImage(secondary || null);
        setPrice(price || format(product.price));
        setComparePrice(comparePrice || null);
    }



    function handleWishlistToggle() {
        const vlid = lid;

        if (isInWishlist) {
            const productData = {
                epi: product.skus[0].id,
                empi: product.productId,
                du: product.url,
            };

            const onSuccess = () => {
                setIsInWishlist(false);
            };

            const onError = (error) => {
                console.error("Error removing from Wishlist:", error);
            };

            _swat.deleteFromList(vlid, productData, onSuccess, onError);
        } else {

            const productData = {
                et: 4,
                epi: product.skus[0].id,
                empi: product.productId,
                du: product.url,
            };

            const onSuccess = () => {
                setIsInWishlist(true);
            };

            const onError = (error) => {
                console.error("Error adding to Wishlist:", error);
            };

            _swat.addToList(vlid, productData, onSuccess, onError);
        }
    }

    useEffect(() => {
        const listConfig = {
            lid: lid,
        };

        const onSuccess = (listContents) => {
            const found = listContents.some((item) => item.empi == product.productId);
            setIsInWishlist(found);
            setLoadingWishlist(false);
        };

        const onError = (error) => {
            console.error("Error fetching List Contents:", error);
            setLoadingWishlist(false);
        };

        if (lid) _swat.fetchListCtx(listConfig, onSuccess, onError);
    }, [lid, product.productId]);

    return (
        <SerpElement
            as="div"
            hit={product}
            data-url={product.url}
            data-product-id={product.productId}
            data-product-handle={product.url ? product.url.split('products/')[1] : ""}
            class="ns-product ns-border-box ns-text-undecorated ns-color-inherit ns-col-12 ns-col-xs-6 ns-col-md-4 ns-col-l-3 ns-p-2 ns-my-2 ns-mx-0"
        >
            <div class="ns-relative pd-card-container">
                
                <CornerTreatment product={product} />

                <a href={product.url} class="pd-image-container">
                    <img
                        class="pd-product-image pd-front-image"
                        src={primaryImage}
                        alt={product.name || "Product image"}
                        width="600"
                        height="400"
                        onError={(e) => (e.target.src = productImagePlaceholder)}
                    />
                    {secondaryImage && (
                        <img
                            class="pd-product-image pd-back-image"
                            src={secondaryImage}
                            alt={`${product.name} alternate`}
                            width="600"
                            height="400"
                            onError={(e) => (e.target.style.display = "none")}
                        />
                    )}
                </a>
                
                <div
                    class={`pd-wishlist pd-cursor-pointer ${isInWishlist ? "pd-wishlist--added" : ""} ${loadingWishlist ? "hidden" : ""}`}
                    onClick={handleWishlistToggle}
                    disabled={loadingWishlist}
                    aria-label={isInWishlist ? "Remove from Wishlist" : "Add to Wishlist"}
                >

                    {/* <img
                        src={isInWishlist ? "https://cdn.shopify.com/s/files/1/0268/9027/2823/files/wishlist_fill.svg?v=1736552600" : "https://cdn.shopify.com/s/files/1/0268/9027/2823/files/wishlist_unfill.svg?v=1736552600"}
                        alt={`${product.name} wishlist icon`}
                    /> */}

                </div>

            </div>
            <div class="ns-relative ns-mt-2" data-nosto-element="product">
                <a
                    href={product.url}
                    class="ns-clipped ns-text-undecorated ns-color-black-alt ns-text-four-lines ns-text-md-two-lines ns-font-5 ns-font-thin pd-line-height-1_5"
                >
                    {product.name || "Unnamed product"}
                </a>
                <StarRating
                    ratingValue={product.ratingValue}
                    reviewCount={product.reviewCount}
                />



                <div>
                    <span
                        class={`pd-font-semi-bold ${product.listPrice && product.listPrice > product.price
                            ? "ns-color-barn-red"
                            : "ns-color-black"
                            }`}
                    >
                        {price}
                    </span>
                    {product.listPrice && product.listPrice > product.price && comparePrice && (
                        <span class="ns-color-black ns-font-4 ns-text-striked ns-ml-2">
                            {comparePrice}
                        </span>
                    )}
                </div>

                {!product.available && (
                    <span class="ns-color-black pd-badge-black ns-font-3 ns-px-2 ns-py-1">
                        OUT OF STOCK
                    </span>
                )}

                <VariantsRelated product={product} onVariantClick={handleVariantClick} />
            </div>
        </SerpElement>
    );
}
